<div class="sf-section photographer-services">
  <h2 class="photographer-services__title">{{'marketplace.photographer.services.title'|transloco}}</h2>

  @if (services !== null && services.length > 0) {
    @for (service of services; track service) {
      <app-photographer-service
        [service]="service"
        [routerLink]="[service.id, 'book']"
      ></app-photographer-service>
    }
  } @else if (services !== null && services.length === 0) {
      <div class="empty-state">
        <img src="assets/images/icon-512.png" alt="Shutterflow">
        <h3>{{'marketplace.photographer.services.empty.title'|transloco: {'name': photographerFirstName} }}</h3>
      </div>
  } @else {
    @for (_ of [0, 1, 2]; track _) {
      <app-photographer-service
        [service]="null"
      ></app-photographer-service>
    }
  }
</div>
